var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.23 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff5c0d;\n      }\n\n      .cls-2 {\n        fill: #e7e4e2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 68.62,
    cy: 75,
    r: 63.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.86,33.37c-5.44,0-9.7-5.31-9.7-12.09,0-11.93,7.33-21.28,16.68-21.28s16.69,9.55,16.69,21.28c0,1.6-1.29,2.89-2.89,2.89s-2.89-1.3-2.89-2.89c0-8.4-5-15.49-10.9-15.49s-10.9,6.95-10.9,15.49c0,3.71,2.06,6.3,3.92,6.3,2.22,0,4.09-2.89,4.09-6.3,0-1.6,1.29-2.89,2.89-2.89s2.89,1.3,2.89,2.89c0,6.78-4.33,12.09-9.87,12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.64,150H22.47c-11.45,0-20.77-9.31-20.77-20.76,0-4.28,2.73-19.08,7.19-42.87,3.02-16.12,6.45-34.39,8.51-47.65,.24-1.58,1.7-2.69,3.3-2.42,1.58,.24,2.66,1.72,2.42,3.3-2.07,13.35-5.51,31.67-8.53,47.83-3.65,19.46-7.09,37.85-7.09,41.8,0,8.26,6.72,14.98,14.98,14.98H116.64c1.6,0,2.89,1.29,2.89,2.89s-1.29,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.64,150c-11.46,0-20.77-9.31-20.77-20.76,0-6.01,5.24-35.38,10.32-63.78,3.46-19.4,6.73-37.72,7.58-44.53,.19-1.52,1.59-2.57,3.05-2.53,1.53,.09,2.72,1.36,2.72,2.89,0,11.17,6.12,43.09,11.03,68.73,4.14,21.6,6.68,35.05,6.68,39.22,0,11.45-9.24,20.76-20.59,20.76Zm-.54-107.3c-1.25,7.17-2.72,15.37-4.22,23.78-4.56,25.51-10.23,57.26-10.23,62.76,0,8.26,6.72,14.98,14.99,14.98s14.81-6.72,14.81-14.98c0-3.83-3.2-20.49-6.58-38.13-3.16-16.49-6.57-34.31-8.78-48.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.88,33.37c-5.54,0-9.88-5.31-9.88-12.09C0,9.35,7.33,0,16.69,0c1.6,0,2.89,1.3,2.89,2.89s-1.3,2.89-2.89,2.89c-6.01,0-10.9,6.95-10.9,15.49,0,3.41,1.87,6.3,4.09,6.3,1.6,0,2.89,1.3,2.89,2.89s-1.3,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.86,33.37H9.88c-1.6,0-2.89-1.3-2.89-2.89s1.3-2.89,2.89-2.89H95.86c1.6,0,2.89,1.3,2.89,2.89s-1.29,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.84,5.79H16.69c-1.6,0-2.89-1.3-2.89-2.89s1.3-2.89,2.89-2.89H102.84c1.6,0,2.89,1.3,2.89,2.89s-1.29,2.89-2.89,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.84,24.18h-5.96c-1.6,0-2.89-1.3-2.89-2.89s1.29-2.89,2.89-2.89h5.96c1.6,0,2.89,1.3,2.89,2.89s-1.29,2.89-2.89,2.89Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.628544720f31b0b3ff1ed794a8ddf148.svg";
export { ForwardRef as ReactComponent };